module.exports = __webpack_public_path__ + "img/banner-interactive-platform.210aaf86.png";